import { render, staticRenderFns } from "./Why.vue?vue&type=template&id=d1a9efce"
import script from "./Why.vue?vue&type=script&lang=js"
export * from "./Why.vue?vue&type=script&lang=js"
import style0 from "./Why.vue?vue&type=style&index=0&id=d1a9efce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports